import { createBrowserHistory } from 'history';
import store from 'store';

export const history = createBrowserHistory();

export const logout = async () => {
  store.dispatch({ type: 'LOGOUT' });
  if (!history.location.pathname.startsWith('/auth')) history.push('/');
};
